import React from 'react'

import mapColors from '../util/map-colors'
import mapKeyColorStyle from '../util/map-key-color-style'

const MapRegionalKey = () => (
  <ul className="cmwf--map-key cmwf--map-key-regional">
    <li>
      <div style={{ backgroundColor: mapColors[1] }} />
      {' '}
      Top state in region
    </li>
    <li>
      <div style={{ backgroundColor: mapColors[2] }} />
      {' '}
      Better-than-average states in region
    </li>
    <li>
      <div style={{ backgroundColor: mapColors[3] }} />
      {' '}
      Worse-than-average states in region
    </li>
  </ul>
)

export default MapRegionalKey



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/map-regional-key.jsx